import { render, staticRenderFns } from "./VendorMasterForm.vue?vue&type=template&id=2ba2d05c"
import script from "./VendorMasterForm.vue?vue&type=script&lang=js"
export * from "./VendorMasterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports